module.exports = __webpack_public_path__ + "static/media/chat-page.840053f2.png";